export default "__VITE_PUBLIC_ASSET__7179346a__"